import React from 'react';
import { BOOKING_STATUSES, STATUS_COLORS, PENDING_COLORS, STATUS_LABELS } from '../../constants/statuses';

const CalendarLegend = ({ unavailableDatesEnabled = false, wwooferInitiatedEnabled = false }) => {
  // Custom legend items that show both pending colors
  const legendItems = [
    { color: PENDING_COLORS.HOST_INITIATED, label: 'Pending (Host Request)' },
    ...(wwooferInitiatedEnabled ? [{ color: PENDING_COLORS.WWOOFER_INITIATED, label: 'Pending (WWOOFer Request)' }] : []),
    { color: STATUS_COLORS[BOOKING_STATUSES.ACCEPTED], label: STATUS_LABELS[BOOKING_STATUSES.ACCEPTED] },
    { color: STATUS_COLORS[BOOKING_STATUSES.IN_PROGRESS], label: STATUS_LABELS[BOOKING_STATUSES.IN_PROGRESS] },
    { color: STATUS_COLORS[BOOKING_STATUSES.COMPLETED], label: STATUS_LABELS[BOOKING_STATUSES.COMPLETED] },
    { color: STATUS_COLORS[BOOKING_STATUSES.CANCELLED], label: STATUS_LABELS[BOOKING_STATUSES.CANCELLED] },
  ];

  return (
    <div className="calendar-legend">
      <div className="legend-items">
        {legendItems.map((item, index) => (
          <div key={index} className="legend-item">
            <div
              className="legend-color"
              style={{ backgroundColor: item.color }}
            />
            <span className="legend-label">{item.label}</span>
          </div>
        ))}
        {unavailableDatesEnabled && (
          <div className="legend-item">
            <div
              className="legend-color legend-color--unavailable"
              style={{ backgroundColor: '#ff000033', border: '1px solid #ff000066' }}
            />
            <span className="legend-label">Unavailable</span>
          </div>
        )}
      </div>
      {unavailableDatesEnabled && (
        <p className="calendar-legend__unavailability-hint">
          To mark dates as unavailable, click and drag across the days you want to block. Click an existing unavailable period to remove it.
        </p>
      )}
    </div>
  );
};

export default CalendarLegend;
